import ListViewWrapper from "core/components/ListViewWrapper";
import Table from "components/broadcasts/BroadcastTable";
import BroadcastFilter from "entities/broadcastFilter";
import Broadcast from "entities/broadcast";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { CreateButton } from "core/components/TableActions";
import pagination from "core/pagination";
import { getGenericData, saveGenericData } from "core/storage/localStorage";

const filterStorageKey = "broadcasts-list-filters";

class BroadcastsListPage extends Component {
    constructor() {
        super();
        this.search = this.search.bind(this);
        this.handleBottomScroll = this.handleBottomScroll.bind(this);
    }

    state = {
        items: [],
        filter: this.initializeFilter(),
        loading: true,
        hasLoadedAllPages: false,
        page: 0
    };

    initializeFilter() {
        const saved = getGenericData(filterStorageKey);
        return saved ? new BroadcastFilter(saved) : new BroadcastFilter();
    }

    search() {
        saveGenericData(filterStorageKey, this.state.filter);
        this.loadPage(0);
    }

    handleBottomScroll() {
        if (!this.state.hasLoadedAllPages) {
            this.loadPage(this.state.page + 1);
        }
    }

    loadPage(page) {
        if (!this.state.loading) {
            const state = { loading: true, page };
            if (page === 0) { state.items = []; }
            this.setState(state);
        }
        Broadcast.search(this.state.filter, page).then(items =>
            this.setState({
                items: page === 0 ? items : this.state.items.concat(items),
                loading: false,
                hasLoadedAllPages: items.length < pagination.pageSize
            }));
    }

    componentDidMount() {
        this.search();
    }

    render() {
        return (
            <ListViewWrapper
                title="Email masivos"
                buttons={[
                    (<CreateButton
                        key="1"
                        onCreate={() => this.props.history.push("/broadcasts/create")}
                        text="Nuevo email masivo"
                    />)
                ]}
            >
                <Table
                    onBottomScroll={this.handleBottomScroll}
                    broadcasts={this.state.items}
                    loading={this.state.loading}
                />
            </ListViewWrapper>
        );
    }
}

export default withRouter(BroadcastsListPage);
